// ============================================
// CTAButton — Reusable call-to-action button
// Variants: primary | secondary | ghost | gold
// ============================================
import styles from './CTAButton.module.css';

function CTAButton({
                       children,
                       variant = 'primary',
                       size = 'md',
                       href,
                       onClick,
                       fullWidth = false,
                       disabled = false,
                       type = 'button',
                       icon,
                   }) {
    const classes = [
        styles.btn,
        styles[`btn--${variant}`],
        styles[`btn--${size}`],
        fullWidth ? styles['btn--full'] : '',
        disabled ? styles['btn--disabled'] : '',
    ]
        .filter(Boolean)
        .join(' ');

    if (href) {
        return (
            <a href={href} className={classes} target="_blank" rel="noopener noreferrer">
                {icon && <span className={styles.icon}>{icon}</span>}
                {children}
            </a>
        );
    }

    return (
        <button type={type} className={classes} onClick={onClick} disabled={disabled}>
            {icon && <span className={styles.icon}>{icon}</span>}
            {children}
        </button>
    );
}

export default CTAButton;